import { render } from "./TrendRadarTable.vue?vue&type=template&id=3031e988&scoped=true"
import script from "./TrendRadarTable.vue?vue&type=script&lang=js"
export * from "./TrendRadarTable.vue?vue&type=script&lang=js"

import "./TrendRadarTable.vue?vue&type=style&index=0&id=3031e988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3031e988"]])

export default __exports__